import React from "react";
export function BlackButton({type, onClickHandler, innerHTML}) {
    const style = {
        marginLeft:'5px',
        width:'50px',
        height:'30px',
        fontSize:'13px',
        background: '#333',
        color: '#fff',
        border:'none',
        cursor:'pointer',
        borderRadius: '5px',
    }

    return (
        <button type={type}
                style={style}
                onClick={onClickHandler}>
            {innerHTML}
        </button>
    )
}

export function PerpleButton({type, onClickHandler, innerHTML}) {
    const style = {
        marginLeft:'5px',
        width:'50px',
        height:'30px',
        fontSize:'13px',
        background: '#472f91',
        color: '#fff',
        border:'none',
        cursor:'pointer',
        borderRadius: '5px',
    }

    return (
        <button type={type}
                style={style}
                onClick={onClickHandler}>
            {innerHTML}
        </button>
    )
}

export function BlueButton({type, onClickHandler, innerHTML}) {
    const style = {
        marginLeft:'5px',
        width:'50px',
        height:'30px',
        fontSize:'13px',
        background: '#3280ff',
        color: '#fff',
        border:'none',
        cursor:'pointer',
        borderRadius: '5px',
    }

    return (
        <button type={type}
                style={style}
                onClick={onClickHandler}>
            {innerHTML}
        </button>
    )
}